/**
 * 知识库 - 停用/启用 确认弹窗
 * UI 严格对齐 web后台.html ConfirmModal（line 1731-1759）
 */
import React, { useState } from 'react'
import { Button, message } from 'antd'
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'
import { KnowledgeListItem, toggleKnowledgeStatus } from '../api/knowledge'

interface ConfirmModalProps {
  target: {
    row: KnowledgeListItem
    action: 'enable' | 'disable'
  } | null
  dispatch: (...args: any[]) => any
  state: any
  onClose: () => void
  onSuccess: () => void
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  target,
  dispatch,
  state,
  onClose,
  onSuccess
}) => {
  const [submitting, setSubmitting] = useState(false)

  if (!target) return null

  const { row, action } = target
  const isDeact = action === 'disable'

  const handleOk = async () => {
    const group_id = state?.group?.groupId || ''
    const user_id = state?.main?.user?.user_id || ''
    if (!group_id || !user_id) {
      message.error('未获取到团队或用户信息')
      return
    }
    setSubmitting(true)
    try {
      await toggleKnowledgeStatus(dispatch, {
        knowledge_id: row.knowledge_id,
        status: isDeact ? 0 : 1,
        group_id,
        user_id
      })
      message.success(isDeact ? '已停用' : '已启用')
      onSuccess()
    } catch (e) {
      message.error((e as Error)?.message || '操作失败')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(15,23,42,.45)',
          zIndex: 60
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: '30%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 420,
          background: '#fff',
          borderRadius: 10,
          zIndex: 61,
          padding: 24,
          boxShadow: '0 24px 48px rgba(15,23,42,.2)'
        }}
      >
        <div style={{ display: 'flex', gap: 14 }}>
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 999,
              background: isDeact ? '#FEF3DB' : '#E7F8EF',
              color: isDeact ? '#D48806' : '#10A66B',
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0
            }}
          >
            {isDeact ? (
              <ExclamationCircleOutlined style={{ fontSize: 20 }} />
            ) : (
              <CheckCircleOutlined style={{ fontSize: 20 }} />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <h3
              style={{
                margin: 0,
                fontSize: 15,
                fontWeight: 600,
                color: '#1F2937'
              }}
            >
              确认{isDeact ? '停用' : '启用'}该检查项？
            </h3>
            <p
              style={{
                margin: '8px 0 0',
                fontSize: 13,
                color: '#6B7280',
                lineHeight: 1.6
              }}
            >
              &quot;<b style={{ color: '#1F2937' }}>{row.inspection}</b>&quot;
              {isDeact
                ? ' 停用后将不再出现在采集与审核流程中，已采集的历史记录不受影响。'
                : ' 启用后将立即纳入采集流程。'}
            </p>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
            marginTop: 18
          }}
        >
          <Button onClick={onClose}>取消</Button>
          <Button
            type="primary"
            danger={isDeact}
            loading={submitting}
            onClick={handleOk}
          >
            确认{isDeact ? '停用' : '启用'}
          </Button>
        </div>
      </div>
    </>
  )
}

export default ConfirmModal
